<template>
<div class="chapter">
<div class="inner_page">
<p class="txc" id="d6e193"><b>Also by the author</b></p>
<p class="txc" id="d6e243"><i>Death of a Nationalist </i><br/><i>Law of Return </i><br/><i>The Watcher in the Pine </i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Pawe_9781569477786_epub_c3_r1.vue?3a416443